import React from 'react';
import PropTypes from 'prop-types';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

// Import styles
import {
	ToastBody,
	ToastErrorList,
	ToastTitle,
	ToastSubTitle,
	StyledIcon,
	Close
} from './styles';

function ToastError({ fileName, err, id }) {
	const { t } = useTranslation();
	const close = () => toast.dismiss(id);
	const errors = err.map(({ code, message }) => <li key={code}>{message}</li>);

	return (
		<ToastBody key={id} id={id}>
			<Close onClick={close} type="close" />
			<ToastTitle>
				<StyledIcon type="exclamation-circle" />
				{t('common_general_error')}
			</ToastTitle>
			<ToastSubTitle>{fileName}</ToastSubTitle>
			<ToastErrorList>{errors}</ToastErrorList>
		</ToastBody>
	);
}

ToastError.propTypes = {
	fileName: PropTypes.string,
	err: PropTypes.array,
	id: PropTypes.string
};

export default ToastError;
